import { T } from "../Typography/T";
import {
  hasNonAsciiCharacters,
  NonAsciiWarning,
} from "../Display/NonAsciiWarning";

type TextCellWeight = "normal" | "medium" | "semibold" | "bold";
type TextCellSize = "xs" | "sm" | "base";
type TextCellColor =
  | "default"
  | "secondary"
  | "muted"
  | "faint"
  | "brand"
  | "green"
  | "red"
  | "orange";

interface TextCellProps {
  value: string | number | undefined;
  weight?: TextCellWeight;
  size?: TextCellSize;
  color?: TextCellColor;
  mono?: boolean;
  warnNonAscii?: boolean;
}

export function TextCell({
  value,
  weight = "medium",
  size = "xs",
  color = "default",
  mono,
  warnNonAscii,
}: TextCellProps) {
  if (value === undefined || value === "") {
    return (
      <T color="faint" size="xs">
        {"\u2014"}
      </T>
    );
  }

  const text = (
    <T weight={weight} size={size} color={color} {...(mono ? { mono } : {})}>
      {value}
    </T>
  );

  if (
    !warnNonAscii ||
    typeof value !== "string" ||
    !hasNonAsciiCharacters(value)
  ) {
    return text;
  }

  // inline-flex, not Row: a block-level flex wrapper fills the cell, so a
  // right-aligned column would left-align only the rows that warn.
  return (
    <span className="inline-flex items-center gap-1">
      {text}
      <NonAsciiWarning text={value} />
    </span>
  );
}
